import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchSubCompanies } from '../../actions/subCompaniesActions';

import SubCompany from './SubCompany.jsx';
import Spinner from '../../../../components/gfx/Spinner';

class SubCompanyList extends Component {
    static propTypes = {
        profileId: PropTypes.number.isRequired,
        subCompanies: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    componentDidMount() {
        return this.props.dispatch(fetchSubCompanies(this.props.profileId));
    }

    renderSubCompanies() {
        const subCompanies = this.props.subCompanies.subCompanies;
        const connectedCompanies = subCompanies.filter(
            (company) => company.connected
        );
        const disconnectedCompanies = subCompanies.filter(
            (company) => !company.connected
        );

        return (
            <div className="grid t-grid grid--cols1to2">
                <div className="grid__unit">
                    <h3>Tilknyttede underselskaper</h3>
                    <ul>
                        {connectedCompanies.map((company) => (
                            <SubCompany
                                company={company}
                                dispatch={this.props.dispatch}
                                key={company.id}
                                profileId={this.props.profileId}
                            />
                        ))}
                    </ul>
                </div>

                <div className="grid__unit">
                    <h3>Ikke tilknyttede underselskaper</h3>
                    <ul>
                        {disconnectedCompanies.map((company) => (
                            <SubCompany
                                company={company}
                                dispatch={this.props.dispatch}
                                key={company.id}
                                profileId={this.props.profileId}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    renderSubCompanySection() {
        return this.props.subCompanies.subCompanies.length === 0 ? (
            <section id="subCompanies" />
        ) : (
            <section id="subCompanies">
                <hr />
                <h2>Underselskaper</h2>
                <p>
                    Stillingsannonser som legges ut gjennom tilknyttede
                    underselskaper vil få inngang til denne bedriftsprofilen.
                </p>

                {this.renderSubCompanies()}
            </section>
        );
    }

    render() {
        return this.props.subCompanies.loading ? (
            <div className="u-text-center">
                <Spinner />
            </div>
        ) : (
            this.renderSubCompanySection()
        );
    }
}

export default connect((state) => ({
    subCompanies: state.subCompanies,
}))(SubCompanyList);
